import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const NewInsurance = memo((props) => {
  const { hospital_id, insurances, addHospitalInsurance } = props;
  const initialInsuranceState = {
    insurance_id: '',
    notes: ''
  }
  const [currentInsurance, setCurrentInsurance] = useState(initialInsuranceState);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setCurrentInsurance({
      ...currentInsurance,
      [e.target.name]: e.target.value,
    })
  };

  const onClinicHospitalInsuranceSubmit = () => {
    if (!currentInsurance.insurance_id) {
      alert("※健保は必須選択です。");
      return
    }

    var data = {
      hospital_insurance: {
        hospital_id: hospital_id,
        insurance_id: parseInt(currentInsurance.insurance_id, 10),
        notes: currentInsurance.notes,
      }
    }

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/api/v1/hospital_insurances`, data)
    .then(resp => {
      console.log("成功");
      console.log(resp.data);
      addHospitalInsurance(resp.data);
      notify("success", "HospitalInsurance successfully created!");
      setCurrentInsurance(initialInsuranceState);
    })
    .catch(e => {
      console.log(e.response);
      // alert(JSON.parse(e.request.responseText).errors);
      notify("error", "HospitalInsurance create Error!");
    })
  }

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="input-group mb-3">
            <span className="input-group-text" id="title-basic-enabled">健保</span>
            <select name="insurance_id" id="basic-insurances" className="form-select" value={currentInsurance.insurance_id} onChange={onChangeData}>
              <option value="">必須選択</option>
              {insurances.map(item => 
                <option key={item.id} value={item.id}>{item.name}</option>
              )}
            </select>
            <input type="text" name="notes" className="form-control w-25" id="basic-notes" value={currentInsurance.notes} placeholder="メモを入力" onChange={onChangeData} />
          </div>
        </div>
        <div className="col-2">
          <button className="btn btn-primary" onClick={onClinicHospitalInsuranceSubmit} disabled={(!currentInsurance.insurance_id)}>
            <i className="far fa-plus-square" /> 追加
          </button>
        </div>
      </div>
    </>
  );
});